export default "__VITE_PUBLIC_ASSET__81c13513__"